import { Box, Center } from "@chakra-ui/react";
import React from "react";

function Dots({ activeIndex, onclick, sliderImage }) {
  return (
    <Center align="center">
      <Box p={2} borderRadius={"13px"} className="all-dots">
        {sliderImage.map((slide, index) => (
          <span
            key={index}
            className={`${activeIndex === index ? "dot active-dot" : "dot"}`}
            onClick={() => onclick(index)}
          ></span>
        ))}
      </Box>
    </Center>
  );
}

export default Dots;
